import { Button } from './button';
import { ListConfirmModal } from '../../modal';
import { IUIElementOptions } from '../../../interfaces/options';
import { Templates } from '../../../compile';

export class ListConfirmModalButton<T> extends Button {
	private modal: ListConfirmModal<T>;
	private hintLabel: KnockoutObservable<string>;
	constructor(
		id: string,
		label: string,
		hintLabel: KnockoutObservable<string>,
		modal: ListConfirmModal<T>,
		icon: string = '',
		options?: IUIElementOptions
	) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				template: Templates.layouts_uiElements_buttonWidget,
				widget: {
					widget: Templates.widgets_listConfirmModalButton
				}
			},
			options || {}
		);
		super(id, label, icon, options);
		this.modal = modal;
		this.hintLabel = hintLabel;
		this.click = () => {
			if (this.editable()) {
				this.modal.open();
				this.onClick.notify();
			}
		};
	}
}
